// Kosten komen als decimale string uit de API (bijv. "1250.00").
export function formatCosts(costs) {
    const amount = Number(costs);

    if (costs === null || costs === undefined || costs === '' || Number.isNaN(amount)) {
        return costs;
    }

    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
}

const planningLabels = {
    on_request: 'Op aanvraag',
    in_consultation: 'In onderling overleg',
    ongoing: 'Doorlopend',
};

// Wanneer de dienst plaatsvindt: "Op aanvraag", "In onderling overleg", "Doorlopend" of de geplande datum.
// Geeft null terug zolang de dienstverlener hier (nog) niets voor heeft ingevuld.
export function formatPlanning(organisation) {
    if (organisation.planning === 'scheduled') {
        return organisation.plannedDate ? formatDate(organisation.plannedDate) : null;
    }

    return planningLabels[organisation.planning] || null;
}

// Datum-velden (bijv. "2026-10-15T00:00:00+02:00") als "15 oktober 2026". Alleen het datumdeel
// telt, zodat de tijdzone van de bezoeker de dag niet kan verschuiven.
export function formatDate(value) {
    const [year, month, day] = value.substring(0, 10).split('-').map(Number);

    return new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })
        .format(new Date(year, month - 1, day));
}
